import { render, staticRenderFns } from "./DashboardRegisteredPaymentsList.vue?vue&type=template&id=763b78e6&"
import script from "./DashboardRegisteredPaymentsList.vue?vue&type=script&lang=js&"
export * from "./DashboardRegisteredPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports